export const MULTILINE_TEXT_ROWS = 3;
